import axios from 'axios';
import { urlAPI_Current } from './config';

export async function startTracking() {
  const codAcesso = localStorage.getItem('codAcesso');
  if (codAcesso) return;
  try {
    const resposeInput = await axios.post(`${urlAPI_Current}/saveAccessDateInput`, {}, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
      }
    });

    localStorage.setItem('codAcesso', resposeInput.data.codAcesso);
  } catch (error) {
    console.error("Erro ao salvar acesso:", error);
  }
}

export async function stopTracking() {
    const codAcesso = localStorage.getItem('codAcesso');
    localStorage.removeItem('codAcesso');
    
    if (!codAcesso) return;
  
    try {
      await axios.post(`${urlAPI_Current}/saveAccessDateExit`, {
        codAcesso: codAcesso,
      } , {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
        }
      });
  
    } catch (error) {
      console.error("Erro ao salvar acesso:", error);
    }
  }
